(function () {
  'use strict';

  function initBanner(banner) {
    var sectionId  = banner.dataset.announcementId;
    var configEl   = document.getElementById('announcement-config-' + sectionId);
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (err) {
      console.error('[Announcement] Invalid config JSON', err);
      return;
    }

    var storageKey = 'announcement_dismissed_' + sectionId;

    if (localStorage.getItem(storageKey)) {
      banner.style.display = 'none';
      return;
    }

    var closeBtn = banner.querySelector('[data-announcement-close]');
    if (closeBtn) {
      closeBtn.removeEventListener('click', closeBtn._handler);
      closeBtn._handler = function () {
        banner.style.display = 'none';
        localStorage.setItem(storageKey, '1');
      };
      closeBtn.addEventListener('click', closeBtn._handler);
    }

    if (config.hasSwiper) {
      initSwiper(banner, config);
    }
  }

  function initSwiper(banner, config) {
    if (typeof Swiper === 'undefined') {
      console.warn('[Announcement] Swiper not loaded');
      return;
    }

    var container = banner.querySelector('.announcement-swiper-' + config.id);
    if (!container) return;

    if (container.swiper) {
      container.swiper.destroy(true, true);
    }

    new Swiper(container, {
      loop:         true,
      slidesPerView: 1,
      direction:    'horizontal',
      observer:     true,
      observeParents: true,
      autoplay: {
        delay:                config.swiperDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter:    true,
      },
      speed: config.swiperSpeed,
      navigation: {
        nextEl: '#announcement-' + config.id + ' .announcement-next',
        prevEl: '#announcement-' + config.id + ' .announcement-prev',
      },
    });
  }

  function initAll() {
    document.querySelectorAll('[data-announcement-id]').forEach(initBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var banner = e.target.querySelector('[data-announcement-id]');
    if (banner) initBanner(banner);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var banner = e.target.closest('[data-announcement-id]');
    if (banner) initBanner(banner);
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var banner = e.target.closest('[data-announcement-id]');
    if (banner) initBanner(banner);
  });

})();
